
import Container from 'react-bootstrap/Container'
import React, { useEffect, useState } from "react";
import { faLeftRight } from '@fortawesome/free-solid-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { Routes, Route } from "react-router";


import MapPage from './components/pages/MapPage';
import HomePage from './components/pages/FaqPage';
import AdminPage from './components/pages/AdminPage';
import CallbackPage from './components/pages/CallbackPage';
import NotFoundPage from './components/pages/NotFoundPage ';
import FaqPage from './components/pages/FaqPage';
import SubscriptionPage from './components/pages/SubscriptionPage'
import MapGlPage from './components/pages/MapGlPage'
import Login from "./components/firebase-auth/login";
import Register from "./components/firebase-auth/register";
import PasswordReset from "./components/firebase-auth/password-reset"
//import Home from "./components/home";

import { AuthProvider } from "./contexts/authContext";
import { useRoutes } from "react-router";

import { AuthenticationGuard } from './components/auth/AuthenticationGuard'
import { SubscriptionGaurd } from './components/auth/SubscriptionGaurd';
import TermsPage from './components/pages/TermsPage';
import PrivacyPage from './components/pages/PrivacyPage';
import { AdminGaurd } from './components/auth/AdminGaurd';


function App() {
    const routesArray = [

      {
        path: "/",
        element: <SubscriptionGaurd component={MapGlPage} />,
      },
      {
        path: "/terms",
        element: <TermsPage />
      },
      {
        path: "/privacy",
        element: <PrivacyPage />
      },
      {
        path: "/login",
        element: <Login />,
      },
      {
        path: "/password-reset",
        element: <PasswordReset />,
      },
      {
        path: "/faq",
        element: <FaqPage/>
      },
      {
        path: "/signup",
        element: <Register />,
      },
      {
        path:"/subscribe",
        element: <AuthenticationGuard component={SubscriptionPage} />,
      },
      {
        path:"/admin",
        element: <AdminGaurd component={AdminPage}/>
      }
    ];
    let routesElement = useRoutes(routesArray);
    return (
      <AuthProvider>
        {routesElement}
      </AuthProvider>
    );
  }

export default App;